import { baseApi } from "../../../api/baseApi.js";
import { prepareQueryParams } from "../../../helpers/index.js";

export const wishlistApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getWishlistItems: build.query({
      query: () => {
        return {
          url: "/getwishlistitems",
          method: "GET",
          params: prepareQueryParams(),
        };
      },
      providesTags: ["Wishlist"],
    }),
    addWishlistItem: build.mutation({
      query: (payload) => {
        return {
          url: "/addwishlistitem",
          method: "POST",
          body: {
            ...prepareQueryParams(),
            ...payload,
          },
        };
      },
      invalidatesTags: ["Wishlist"],
    }),
    removeWishlistItem: build.mutation({
      query: (payload) => {
        return {
          url: "/removewishlistitem",
          method: "POST",
          body: {
            ...prepareQueryParams(),
            ...payload,
          },
        };
      },
      invalidatesTags: ["Wishlist"],
    }),
    addCompanions: build.mutation({
      query: (payload) => {
        return {
          url: "addcompanions",
          method: "Post",
          body: {
            ...prepareQueryParams(),
            companions: payload,
          },
        };
      },
      invalidatesTags: ["Wishlist"],
    }),
  }),
});

export const {
  useGetWishlistItemsQuery,
  useAddWishlistItemMutation,
  useRemoveWishlistItemMutation,
  useAddCompanionsMutation,
} = wishlistApi;
